/**
 * @import { RenderModalBackdropProps } from '@restart/ui/Modal'
 */

/**
 * @param {RenderModalBackdropProps} props
 * @returns {React.JSX.Element | false}
 */
export function Backdrop(props) {
  return <div {...props} style={{ position: 'absolute', inset: 0, background: '#000', opacity: 0.5, zIndex: 99 }} />;
}
